module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "header-wrapper"
  }, [_c('div', {
    staticClass: "header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "nav"
  }, [_c('ul', [_c('li', [_c('router-link', {
    staticClass: "item",
    staticStyle: {
      "color": "#0a8ddf"
    },
    attrs: {
      "to": "/movie"
    }
  }, [_vm._v("电影")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item",
    staticStyle: {
      "color": "#9F7860"
    },
    attrs: {
      "to": "/book"
    }
  }, [_vm._v("图书")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item",
    staticStyle: {
      "color": "#E4A813"
    },
    attrs: {
      "to": "/broadcast"
    }
  }, [_vm._v("广播")])], 1), _vm._v(" "), _c('li', [_c('router-link', {
    staticClass: "item",
    staticStyle: {
      "color": "#2AB8CC"
    },
    attrs: {
      "to": "/group"
    }
  }, [_vm._v("小组")])], 1)]), _vm._v(" "), _c('span', {
    staticClass: "search-btn",
    on: {
      "click": _vm.showSearch
    }
  })]), _vm._v(" "), _c('transition', {
    attrs: {
      "enter-active-class": "animated fadeInLeft",
      "leave-active-class": "animated fadeOutRight"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.isShowSearch),
      expression: "isShowSearch"
    }],
    staticClass: "search-wrapper"
  }, [_c('span', {
    staticClass: "close",
    on: {
      "click": _vm.showSearch
    }
  }, [_vm._v("关闭")]), _vm._v(" "), _c('form', {
    staticClass: "form",
    attrs: {
      "action": "/search",
      "method": "GET"
    }
  }, [_c('div', [_c('input', {
    attrs: {
      "type": "search",
      "name": "query"
    }
  })])]), _vm._v(" "), _c('ul', {
    staticClass: "nav-list"
  }, _vm._l((_vm.NavData), function(nav) {
    return _c('li', [_c('a', {
      attrs: {
        "href": ""
      }
    }, [_c('strong', {
      style: ({
        'color': nav.color
      })
    }, [_vm._v(_vm._s(nav.title))]), _vm._v(" "), _c('span', [_vm._v(_vm._s(nav.description))])])])
  })), _vm._v(" "), _c('div', {
    staticClass: "navBottom"
  }, [_c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("注册账号")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("登录豆瓣")])]), _vm._v(" "), _c('div', {
    staticClass: "nav-item"
  }, [_c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("使用桌面版")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": ""
    }
  }, [_vm._v("使用豆瓣APP")])])])])])], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', [_c('a', {
    staticClass: "title",
    attrs: {
      "href": "#"
    }
  }, [_vm._v("豆瓣")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-33b4cec1!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/header/header.vue
// module id = 56
// module chunks = 1